import {DOCUMENT, EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer} from '@angular/core';
import {MemoizedSelector} from '@ngrx/store';
import {COVER_IMAGE_SOURCE, FALLBACK_COVER_IMAGE_URL} from '@aviary/injection-tokens/app-provided.tokens';
import {select} from '@aviary/store/store.helpers';
import {BOWKER_ORIGIN, CHILI_FRESH_ORIGIN} from '@aviary/injection-tokens/aviary-only.tokens';
import {CoverImageSource} from '@aviary/store/common/common.types';

export interface CoverImageProvidersConfig {
  coverImageSourceSelector: MemoizedSelector<object, CoverImageSource>;
  fallbackCoverImageUrl: string;
}

export function provideAviaryCoverImages(config: CoverImageProvidersConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideCoverImagePreconnects(),
    {provide: COVER_IMAGE_SOURCE, useFactory: () => select(config.coverImageSourceSelector)},
    {provide: FALLBACK_COVER_IMAGE_URL, useValue: config.fallbackCoverImageUrl}
  ]);
}

function provideCoverImagePreconnects(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const document: Document = inject(DOCUMENT);
    const originsNeedingPreconnectLinks: Set<string> = new Set([inject(CHILI_FRESH_ORIGIN), inject(BOWKER_ORIGIN)]);

    const originsWithExistingPreconnectLinks: Set<string> = new Set(
      Array.from(document.head.querySelectorAll<HTMLLinkElement>('link[rel="preconnect"]')).map(link => new URL(link.href).origin)
    );

    for (const origin of originsNeedingPreconnectLinks) {
      if (originsWithExistingPreconnectLinks.has(origin)) continue;

      const link: HTMLLinkElement = document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      document.head.appendChild(link);
    }
  });
}
